module.exports = __webpack_public_path__ + "media/images/expert__david-lemos-459d4788179a2940f3d326fe079e78f6.png";